// extracted by mini-css-extract-plugin
export default {"capturedImage":"RD8_ysSzS32ua0a0Idew","frame":"d9jw2s1JtXdCQ8tBMUTz","mirror":"BdNjfZNbIMO9z8Sxfhq6"};